import styled from 'styled-components/macro';
import { colorCoreGray500 } from '@yme/tokens/colors';
export const ContainerStyled = styled.div `
  border-top: 1px solid ${colorCoreGray500};
  padding: 24px 0;
`;
export const SectionContainerStyled = styled.div `
  margin-bottom: 16px;
`;
export const QuantityContainerStyled = styled.div `
  width: 78px;
`;
